// Persists the CGTrader AI notification toggles (first-generation popover and
// Settings modal) client-side. Best-effort; storage may be unavailable
// (private mode, quota). Server-side gating of the email itself is a
// follow-up: today the flag only records the user's choice.

export const NOTIFICATION_PREFERENCES_KEY = 'ai_studio_notification_preferences'
export const NOTIFICATIONS_POPOVER_SEEN_KEY = 'ai_studio_notifications_popover_seen'

export const DEFAULT_NOTIFICATION_PREFERENCES = {
  emailWhenReady: false,
  browserNotifications: false,
}

export const readNotificationPreferences = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(NOTIFICATION_PREFERENCES_KEY))
    if (!stored || typeof stored !== 'object') return { ...DEFAULT_NOTIFICATION_PREFERENCES }

    return {
      emailWhenReady: Boolean(stored.emailWhenReady),
      browserNotifications: Boolean(stored.browserNotifications),
    }
  } catch (_) {
    return { ...DEFAULT_NOTIFICATION_PREFERENCES }
  }
}

export const writeNotificationPreferences = (preferences) => {
  try {
    window.localStorage.setItem(NOTIFICATION_PREFERENCES_KEY, JSON.stringify({
      emailWhenReady: Boolean(preferences.emailWhenReady),
      browserNotifications: Boolean(preferences.browserNotifications),
    }))
  } catch (_) {
    // No-op.
  }
}

export const hasSeenNotificationsPopover = () => {
  try {
    return window.localStorage.getItem(NOTIFICATIONS_POPOVER_SEEN_KEY) === 'true'
  } catch (_) {
    return true
  }
}

export const markNotificationsPopoverSeen = () => {
  try {
    window.localStorage.setItem(NOTIFICATIONS_POPOVER_SEEN_KEY, 'true')
  } catch (_) {
    // No-op.
  }
}
